export default __webpack_public_path__ + "static/media/facebook.6141fe8d.svg";